<template>
  <div class="lsAbs">
    <BackSection :menu="name" />
    <div class="container-fluid py-2">
      <ListAbsenMasuk />
    </div>
  </div>
</template>
<script>
import ListAbsenMasuk from "@/components/ListAbsenMasuk.vue";
import BackSection from "@/components/BackSection.vue";
export default {
  setup() {
    return {
      name: "List Absensi Anda",
    };
  },
  components: {
    BackSection,
    ListAbsenMasuk,
  },
};
</script>
